import { IAccount, IAccountMappingTemplate, IBalanceSwitchAccount } from '@modeso/types__aumico-lib-annualreport-be';
import { AccountMappingTemplateStatus } from '../enums/account-mapping-template-status.enum';

export interface IAccountMappingDataAutoFilled {
    template: IAccountMappingTemplate;
    status:
        | AccountMappingTemplateStatus.AUTOFILLED
        | AccountMappingTemplateStatus.PREVIOUS_AUTOMATIC_FILL
        | AccountMappingTemplateStatus.COPY_FROM_OTHER_REPORT;
    accounts: IAccount[];
    balanceSwitchAccounts?: IBalanceSwitchAccount[];
}
